<template>
    <button
        v-tippy="t('editorRemoveLink')"
        :class="[
            buttonState(
                editor.can().toggleLink({
                    href: 'https://',
                }) && editor.isActive('link'),
                editor.isActive('link'),
            ),
            'flex-none rounded p-1 text-sm',
        ]"
        :disabled="!editor.can().unsetLink() || !editor.isActive('link')"
        @click="editor.chain().focus().unsetLink().run()"
    >
        <MdiLinkOff class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiLinkOff from 'materialdesignicons-vue3/icons/MdiLinkOff.js';

    defineExpose({
        name: 'LinkRemoveButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
